/**
 * Explore Customers By Vertical
 *
 * UI for handling the logic and animations of Explore Customers By Vertical
 */

 const $ = require( 'jquery' );
 import VerticalHandler from "../VerticalHandler";

 var itblExploreCustomersByVertical = function(el){
 
   //setup some variables
   this.$el         = $(el);
   this.$vertical   = this.$el.find('.js-itbl-b-explore-customers-by-vertical__vertical');
   this.verticalHandler = new VerticalHandler();
 
   this.init();
 };
 
 itblExploreCustomersByVertical.prototype.init = function(){
 
   this.events();
 
 };
 
 itblExploreCustomersByVertical.prototype.events = function(){
  const handleVerticalSelect = this.event__handleVerticalSelect.bind(this);

  this.verticalHandler.onVerticalChange(vertical => {
    this.event__handleVerticalSelect(vertical);
  });

  this.$vertical.on('click', e => {
    e.preventDefault();
    const vertical = $(event.currentTarget).data("vertical-slug");
    this.verticalHandler.changeVertical(vertical);
  });
 };
 
 itblExploreCustomersByVertical.prototype.event__handleVerticalSelect = function (vertical){
    $('.itbl-b-explore-customers-by-vertical__vertical.active-vertical')
      .removeClass('active-vertical');
    $(
      `.itbl-b-explore-customers-by-vertical__vertical[data-vertical-slug=${vertical}]`
    ).addClass('active-vertical');

    let verticalSlug = vertical;
    $('.itbl-b-explore-customers-by-vertical__no-customers').hide();

    if(verticalSlug === 'all') {
        $('.itbl-b-explore-customers-by-vertical__customer').show();
    } else {
        $('.itbl-b-explore-customers-by-vertical__customer').hide();
        if($('.itbl-b-explore-customers-by-vertical__customer.'+ verticalSlug).length > 0) {
            $('.itbl-b-explore-customers-by-vertical__customer.'+ verticalSlug).show();
        } else {
            $('.itbl-b-explore-customers-by-vertical__no-customers').show();
        }
    }
 }
 
 $(document).ready(function(){
   $('.itbl-b-explore-customers-by-vertical').each(function(){
     new itblExploreCustomersByVertical(this);
   });
 }); 
 